import { CustomImage as Image } from '../../../';
import styles from './index.module.css';

const HsaFsaDataContent = [
  {
    title: 'Mark your eligibility',
    description: `On the pricing page, select “Yes” if you're using an HSA/FSA card.`,
    image: '1.png',
  },
  {
    title: `Click on “Proceed to pay”`,
    description: 'This will take you to the payment screen.',
    image: '2.png',
  },
  {
    title: 'Pay using your HSA/FSA card',
    description: 'Enter your HSA or FSA card details to complete the purchase.',
    image: '3-1.png',
  },
];

export const HsaFsaOffer = ({ className }: { className?: string }) => {
  return (
    <div className={`${styles.root}${className ? ` ${className}` : ''}`}>
      <h3>Use your FSA/HSA to save on your Blood Vision subscription</h3>

      <p className={styles.description}>
        Save more with your pre-tax dollars. The blood vision subscription is
        now HSA/FSA eligible.
      </p>
      <div className={styles.imgContainer}>
        <Image
          src={'web_v2/blood-vision/modal/Cover_hsa_fsa.png'}
          fill
          alt="trade-in"
        />
      </div>
      <div className={styles.content}>
        <p className={styles.directions}>How it works</p>
        <br />
        {/* ------ */}
        <br />

        {HsaFsaDataContent.map((item, index) => {
          return (
            <>
              <h4>
                <span className={styles.caption}>STEP {index + 1}</span>
                {HsaFsaDataContent[index].title}
              </h4>
              <p>{HsaFsaDataContent[index].description}</p>
              <div className={styles.imgContainer}>
                <Image
                  src={`web_v2/blood-vision/modal/Step${index + 1}.png`}
                  fill
                  alt="blood-vision"
                />
              </div>
              <br />
            </>
          );
        })}

        <br />
        {/* ------ */}
        <br />
        <br />

        <p>
          Need help? Reach out anytime at{' '}
          <a href="mailto:support@ultrahuman.com">support@ultrahuman.com</a> —
          we&apos;ve got your back.
        </p>
        <br />
        <br />

        {/* <Link href={'/hsa-fsa'} className="cta" passHref>
          <PrimaryCTA color="black">Explore now</PrimaryCTA>
        </Link> */}
      </div>
    </div>
  );
};
